import { Dictionary, isUndefined, isEmpty } from 'lodash';
import { Nullable, omitDeepUndefined } from '../../utils';
import { Bookmark } from './Bookmark';

export type BookmarkUpdateData = Nullable<
  Partial<
    Pick<
      Bookmark,
      | 'assignmentInfo'
      | 'isHidden'
      | 'seenAt'
      | 'groupId'
      | 'hasUnseenComments'
      | 'startDate'
      | 'closeDate'
      | 'isArchived'
      | 'module'
      | 'order'
    >
  >
>;

export namespace BookmarkUpdateData {
  export function updateFields(data: BookmarkUpdateData): object {
    const updateFields: Dictionary<any> = {};
    if (!isUndefined(data.seenAt)) updateFields['seenAt'] = data.seenAt;
    if (!isUndefined(data.assignmentInfo)) updateFields['assignmentInfo'] = data.assignmentInfo;
    if (!isUndefined(data.groupId)) updateFields['groupId'] = data.groupId;
    if (!isUndefined(data.isHidden)) updateFields['isHidden'] = data.isHidden;
    if (!isUndefined(data.isArchived)) updateFields['isArchived'] = data.isArchived;
    if (!isUndefined(data.hasUnseenComments)) updateFields['hasUnseenComments'] = data.hasUnseenComments;
    if (!isUndefined(data.startDate)) updateFields['startDate'] = data.startDate;
    if (!isUndefined(data.closeDate)) updateFields['closeDate'] = data.closeDate;
    if (!isUndefined(data.module)) updateFields['module'] = data.module;
    if (!isUndefined(data.order)) updateFields['order'] = data.order;

    const cleaned = omitDeepUndefined(updateFields);
    if (!isEmpty(cleaned)) {
      cleaned['modifiedAt'] = Date.now();
    }
    return cleaned;
  }
}
